import { IncrementalTicker } from '@/types/generated/common/types'

// Priority order for sorting tickers in UI (not a filter)
export const PRIORITY_TICKERS = [
  'BTC',
  'BTC_USDC',
  'ETH',
  'ETH_USDC',
  'SOL',
  'SOL_USDC',
  'XRP',
  'XRP_USDC',
  'TRX',
  'TRX_USDC',
  'AVAX',
  'AVAX_USDC',
] as const

export interface ParsedSymbol {
  ticker: string // 'BTC' or 'BTC_USDC'
  baseCurrency: string // 'BTC'
  expiry: string // "26DEC25"
  expirationTsMs?: string
  strike: number
  type: 'C' | 'P' // "Call" or "Put"
}

export interface GroupedOptionEntry {
  symbol: string
  strike: number
  type: 'C' | 'P'
}

export interface GroupedInstruments {
  ticker: string
  expires: Map<string, GroupedOptionEntry[]> // expiry -> entries[] @description after selecting symbol, the user manually select the expiry inside of option-chain-table.
  expiryTsMs: Map<string, number> // expiry -> millisecond timestamp from instrument.expirationTsMs
}

export interface OptionRowType {
  // The ITM verdicts, not the underlying price itself: a row only ever needs to know
  // which side of the money this strike is on, so passing the raw price made every row
  // re-render on every tick. Computed by the option table, which owns the price.
  isCallItm: boolean
  isPutItm: boolean
  strike: number
  call?: IncrementalTicker
  put?: IncrementalTicker
  isLoading?: boolean
}
